<template>
<div>
    <h2 style="text-align: center;">Информация о товаре</h2>

    <app-alert v-if="loading"></app-alert>
    <div class="foralert" v-else-if="error" @click="alertClick">
        <alert :msg="msg"></alert>
    </div>

    <b-row v-else>
        <div class="foritem">

            <div class="forimg">
                <img :src="item.img" :alt="`${item.article}`">

            </div>
            <div class="fortext item">
                <h5>Наименование: {{item.brand}} {{item.article}}</h5>
                <strong>Описание: </strong>
                <p v-for="(i,index) in getDescr" :key="index">{{ i }}</p>
                <strong>Стоимость: <span>{{ getPrice(item.price.toString()) }}</span><i class="fa fa-rub" area-hidden="true"></i></strong>
                <div class="forbtn">
                  <b-btn variant="outline-primary" @click="handleCopy" :disabled="copyStatus">{{copyStatus ? 'Ссылка скопирована':'Скопировать ссылку на эту страницу'}}</b-btn>  
                </div>
                
            </div>
        </div>

        <hr>

        <div class="forbrand" v-if="brand">
            <h4>Информация о производителе</h4>
            <div class="forhead">
                <div class="forimg">
                    <img :src="`../${brand.img_path}`" :alt="brand.title">
                </div>
                <div class="text">
                    <h5>Наименование: {{brand.title}}</h5>
                    <span><strong>Специализация: </strong>{{brand.spec}}</span>
                </div>
            </div>
            <div class="brandtext">
                <p><strong>Описание: </strong>{{brand.descr}}</p>
                <div class="right" v-if="brand.url_en"><a :href="brand.url_en" target="_blank"><strong>Cайт производителя (EN)</strong></a></div>
                <div class="right" v-if="brand.url_ru"><a :href="brand.url_en" target="_blank"><strong>Cайт производителя (RU)</strong></a></div>
            </div>
            <br />

        </div>

    </b-row>

</div>
</template>

<script>
import Vue from 'vue'

import AppAlert from "../components/AppAlert.vue"
import Alert from "../components/Alert.vue"

export default {
    created() {
        this.getItem()
    },
    data() {
        return {
            id: this.$route.params.id,
            tbl: this.$route.query.tbl,
            item: null,
            brand: null,
            loading: true,
            error: false,
            msg: {},
            thingToCopy: `https://ligasound.ru${this.$route.fullPath}`,
            copyStatus: null
        }
    },
    components: {
        AppAlert,
        Alert
    },
    methods: {
        async getItem() {
            if (this.tbl === 'ligasound') {
                await Vue.http.get('1.json')
                    .then(res => {
                        let arr = res.data
                        let items = qq(arr)
                        this.item = this.getItemLS(items)
                    })
                    .catch(e => {
                            this.msg.type = 'error'
                            this.msg.arr = ['Ошибка получения данных. ', `${e.message}`]
                        }

                    )

            } else {
                await Vue.http.get('product.php', {
                        params: {
                            id: this.id,
                            tbl: this.tbl,
                            cat: this.$route.query.cat
                        }
                    }).then(r => {
                        let res = r.data.res
                        if (!res) {
                            this.msg.type = 'error'
                            this.msg.arr = ['Ошибка обработки данных. ', `${r.data}`]
                            this.error = true

                        } else if (res === 'success') {
                            this.item = r.data.item
                            this.brand = r.data.brand

                        } else {
                            this.msg.type = 'error'
                            this.msg.arr = r.data.msg
                            this.error = true
                        }
                    })
                    .catch(e => {
                        this.msg.type = 'error'
                        this.msg.arr = ['Ошибка получения данных. ', `${e.mwssage}`]
                    })
            }
            this.loading = false
        },
        alertClick() {
            this.error = false
            this.$router.push('/')
        },
        getItemLS(items) {
            let itemLS = {}

            let item = items.find(item => item.Code === this.id)
            if (!item) {
                this.msg.type = 'error'
                this.msg.arr = ['Товар с таким ИД не найден', 'Или уже продан :)']
                this.error = true
                return false
            }

            itemLS.id = this.id
            itemLS.article = this.id
            itemLS.descr = item.Name
            itemLS.price = item.Price
            itemLS.img = `/src/assets/FotoTovarov/${item.Code}.jpg`
            itemLS.nal = 'true'
            itemLS.brand = item.Name
            itemLS.sklad = 'ligasound'
            itemLS.count = 1
            itemLS.maxCount = item.Number

            return itemLS

        },
        handleCopy() {
            
            this.$copyText(this.thingToCopy).then(e=> {
                this.copyStatus = true
            }, e=>{
                this.copyStatus = false
            })
        },
         getPrice(price) {
           let reg = /(\d)(?=(\d\d\d)+([^\d]|$))/g
            return price.replace(reg, '$1 ')
        }

    },
    computed: {
        getDescr() {
            let arr = []

            if (this.item.sklad === 'invask') {
                arr = this.item.descr.split('\n')
            } else if (this.item.sklad === 'lutner') {
                arr = this.item.descr.split(',')
            } else if (this.item.sklad === 'dynatone') {
                arr = this.item.descr.split('.')
            } else {
                arr.push(this.item.descr)
            }
            return arr
        }
       
    }

}
let qar = []

function qq(arr) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].IsFolder) {
            qq(arr[i].Elements)
        } else {
            qar.push(arr[i])
        }

    }
    return qar
}
</script>

<style scoped>
.row {
    align-items: center;
}

.foritem {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 10px auto;
}

.forimg {
    flex-basis: 20%;
    margin: 0 auto;
    max-width: 300px;
    min-width: 150px;
}

.fortext,
.forhead,
.text {
    width: 80%;
    margin: 0 auto;
}


.fortext p {
    margin: 0.2rem;
    text-align: justify;
}

h4 {
    text-align: center;
}

.forhead {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.brandtext {
    text-align: justify;
    padding: 0 25px;
}

.right {
    text-align: right;
}
</style>
